export default __webpack_public_path__ + "static/Leaf6-1d650b7eb55e4646777e48263e18fd4f.png";